import { Text } from '@typedream/ui';
import { MdCheck } from 'react-icons/md';
import Image from 'next/image';
import styles from './SignupRightSection.module.css';

function SignupRightSection() {
  return (
    <div className={styles.root}>
      <Image
        className={styles.onboardingImage}
        src="/images/login-illust-ai-builder.png"
        width={888}
        height={589}
        alt="Login page illustration"
      />
      <div className="absolute left-[112px] top-[580px] pl-16 w-full max-w-[60%]">
        <Text as="h2" variant="main" size="2xl" weight="bold">
          A complete toolkit to launch
          <br />
          your business online
        </Text>
        <ul className="space-y-2 mt-5 list-none">
          <li className="flex items-center space-x-2">
            <MdCheck className="text-accent" aria-hidden />
            <Text variant="secondary" size="lg" weight="medium">
              Generate sitemap & wireframes with AI
            </Text>
          </li>
          <li className="flex items-center space-x-2">
            <MdCheck className="text-accent" aria-hidden />
            <Text variant="secondary" size="lg" weight="medium">
              Edit, customize, and publish your site
            </Text>
          </li>
          <li className="flex items-center space-x-2">
            <MdCheck className="text-accent" aria-hidden />
            <Text variant="secondary" size="lg" weight="medium">
              Accept payments, add forms, and more
            </Text>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SignupRightSection;
